export const OmegaRandom = {
    READY: "assets/omega/ready/interface-03.png",
    HOME: [
        "assets/omega/home/Page1-001-01.png",
        "assets/omega/home/Page1-001-02.png",
        "assets/omega/home/Page1-001-03.png",
        "assets/omega/home/Page1-001-04.png",
        "assets/omega/home/Page1-001-05.png",
        "assets/omega/home/Page1-001-06.png",
        "assets/omega/home/Page1-001-07.png",
        "assets/omega/home/Page1-001-08.png",
        "assets/omega/home/Page1-001-09.png",
        "assets/omega/home/Page1-001-10.png",
        "assets/omega/home/Page1-001-11.png",
        "assets/omega/home/Page1-001-12.png",
    ],
    START: [
        "assets/omega/start/Page2-001-01.png",
        "assets/omega/start/Page2-001-02.png",
        "assets/omega/start/Page2-001-03.png",
        "assets/omega/start/Page2-001-04.png",
        "assets/omega/start/Page2-001-05.png",
        "assets/omega/start/Page2-001-06.png",
        "assets/omega/start/Page2-001-07.png",
        "assets/omega/start/Page2-001-08.png",
        "assets/omega/start/Page2-001-09.png",
    ],
}